import React, { useState, useEffect, useRef, useMemo, useContext } from "react";
import styles from "./Purchase.module.css";
import { StockContext } from "../../Context/StockContext";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { toCommas } from "../../utils/utils";
import { toCreatorRef, getAuthUserId } from "../../utils/ids";
import { useSnackbar } from "react-simple-snackbar";
import AddSupplier from "../Suppliers/AddSupplier";
import IconButton from "@material-ui/core/IconButton";
import DeleteOutlineRoundedIcon from "@material-ui/icons/DeleteOutlineRounded";
import { fetchPurchasesCount } from "../../api/index";
import DateFnsUtils from "@date-io/date-fns";
import { getAllCategories } from "../../actions/categoryActions";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import TextField from "@material-ui/core/TextField";
import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import InputBase from "@material-ui/core/InputBase";
import { Container, Grid } from "@material-ui/core";
import Avatar from "@material-ui/core/Avatar";
import Divider from "@material-ui/core/Divider";
import SaveIcon from "@material-ui/icons/Save";
import Button from "@material-ui/core/Button";
import Chip from "@material-ui/core/Chip";
import { initialStatePurchase } from "../../initialStatePurchase";
import currencies from "../../currencies.json";
import {
  createPurchase,
  getPurchase,
  updatePurchase,
} from "../../actions/purchaseActions";
import { createStock, deleteStockById } from "../../actions/stockActions";
import SignaturePad from "./SignaturePad";
import { getClientsByUser, getAllClients } from "../../actions/clientActions";
import { getAllSuppliers } from "../../actions/supplierActions";
// import {getItems } from '../../actions/itemActions'
import AddClient from "./AddClient";
import PurchaseType from "./PurchaseType";
import axios from "axios";
import { useLocation } from "react-router-dom";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import { getItemsByUser, getAllItems } from "../../actions/itemActions";
import { endOfDay } from "date-fns";
// import AddItem from '../Items/addItem'

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  large: {
    width: theme.spacing(12),
    height: theme.spacing(12),
  },
  table: {
    minWidth: 650,
    padding: theme.spacing(3),
  },

  headerContainer: {
    // display: 'flex'
    paddingTop: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 150,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));
const options = {
  position: "bottom",
  style: {
    backgroundColor: "red",
    border: "2px solid red",
    color: "white",
    fontFamily: "Menlo, monospace",
    fontSize: "20px",
    textAlign: "center",
  },
  closeStyle: {
    color: "lightcoral",
    fontSize: "16px",
  },
};
const Purchase = () => {
  const location = useLocation();
  const [purchaseData, setPurchaseData] = useState(initialStatePurchase);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [rates, setRates] = useState(0);
  const [vat, setVat] = useState(0);
  const [currency, setCurrency] = useState(currencies[1].value);
  const [subTotal, setSubTotal] = useState(0);
  const [total, setTotal] = useState(0);
  const { categories } = useSelector((state) => state.categories);

  const [error, setError] = useState("");
  const [client, setClient] = useState(null);
  const [defaultClient, setDefaultClient] = useState(null);
  const [editQty, setEditQty] = useState(false);
  const inputRef = useRef(null);
  // const [signatureDataUrl, setSignatureDataUrl] = useState(null)
  //console.log(client);
  const [timer, setTimer] = useState(null);
  // (supplier);
  const [searchQuery, setSearchQuery] = useState("");
  const [openSnackbar, closeSnackbar] = useSnackbar(options);
  // const [item, setItem] = useState(null);
  const [type, setType] = useState("Purchase");
  const [status, setStatus] = useState("");
  const { id } = useParams();
  // const [scanning, setScanning] = useState(false);
  const clients = useSelector((state) => state.clients.clients);
  const suppliers = useSelector((state) => state.suppliers.suppliers);
  const { getCurrentStockQty } = useContext(StockContext);
  const [supplier, setSupplier] = useState(null);
  const { getConvertedQuantity } = useContext(StockContext);
  const items = useSelector((state) => state.items.items);
  console.log(items);
  const { purchase } = useSelector((state) => state.purchases);
  const [itemsData, setItemsData] = useState([]);
  //console.log(itemsData);

  //console.log(purchaseData);

  const dispatch = useDispatch();
  const history = useHistory();
  const user = JSON.parse(localStorage.getItem("profile"));
  const today = new Date();

  const [selectedDate, setSelectedDate] = useState(
    today.getTime() + 7 * 24 * 60 * 60 * 1000
  );
  useEffect(() => {
    getTotalCount();
    // eslint-disable-next-line
  }, []);

  const getTotalCount = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API}/purchases/count?searchQuery=${user?.result?.id}`
      );
      const currentDate = new Date();
      // console.log("Date: ", currentDate);

      const purchaseCount = response.data;
      const sequentialPurchaseNumber = purchaseCount + 1;

      // const year = currentDate.getFullYear();
      // const month = String(currentDate.getMonth() + 1).padStart(2, "0");
      // const day = String(currentDate.getDate()).padStart(2, "0");
      // const hours = String(currentDate.getHours()).padStart(2, "0");
      // const minutes = String(currentDate.getMinutes()).padStart(2, "0");
      // const seconds = String(currentDate.getSeconds()).padStart(2, "0");
      // const randomID = Math.floor(100 + Math.random() * 900);
      // const purchaseNumber = `${randomID}${seconds}`;
      // const purchaseNumber = `${year}${month}${day}${hours}${minutes}${seconds}`;

      // console.log("CurrentDate", currentDate);

      //   console.log(response.data);
      //Get total count of purchase from the server and increment by one to serialized numbering of purchase
      setPurchaseData({
        ...purchaseData,
        // purchaseNumber: purchaseNumber,
        purchaseNumber: sequentialPurchaseNumber.toString(), // "1", "2", "3", etc.
      });
    } catch (error) {
      console.error(error);
    }
  };
  // Listen for changes in the form data
  useEffect(() => {
    // Whenever formData changes, set hasUnsavedChanges to true
    setHasUnsavedChanges(true);
  }, [purchaseData]);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (hasUnsavedChanges) {
        // Display a confirmation message
        e.preventDefault();
        e.returnValue = " Are you sure you want to leave this page?";
      }
    };

    // Attach the event listener
    window.addEventListener("beforeunload", handleBeforeUnload);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [hasUnsavedChanges]);
  useEffect(() => {
    dispatch(getPurchase(id));

    // eslint-disable-next-line
  }, [id]);
  useEffect(() => {
    if (!categories.length) {
      dispatch(getAllCategories());
    }
  }, [dispatch, categories]);

  useEffect(() => {
    if (purchase && purchase.items && purchase.items.length > 0) {
      // Extracting id and name from each item and creating a new array of objects
      const extractedData = purchase.items.map((item) => ({
        id: item.id,
        quantity: item.quantity,
      }));
      setItemsData(extractedData);
    }
  }, [purchase]);
  useEffect(() => {
    const defaultClient = clients.filter((clt) => clt.name === "Cash");
    console.log("Default Client", defaultClient);
    setDefaultClient(defaultClient[0]);
  }, [clients]);
  useEffect(() => {
    dispatch(
      // getClientsByUser({ search: user?.result.id || user?.result?.googleId })
      getAllClients()
    );
    dispatch(
      // getClientsByUser({ search: user?.result.id || user?.result?.googleId })
      getAllSuppliers()
    );

    dispatch(
      // getItemsByUser({ search: user?.result.id || user?.result?.googleId })
      getAllItems()
    );
    // eslint-disable-next-line
  }, [dispatch]);
  useEffect(() => {
    if (!purchase) {
      setClient(null);
      setSupplier(null);
    }
  }, [location]);
  useEffect(() => {
    if (purchase) {
      console.log("purchase", purchase);
      //Automatically set the default purchase values as the ones in the purchase to be updated
      setPurchaseData(purchase);
      setRates(purchase.rates);
      setClient(purchase.client);
      setSupplier(purchase.supplier);
      setType(purchase.type);
      setStatus(purchase.status);
      setSelectedDate(purchase.dueDate);
      // setSignatureDataUrl(purchase.signatureDataUrl);
    }
  }, [purchase]);

  // useEffect(() => {
  //   if (type === "Receipt") {
  //     setStatus("Paid");
  //   } else {
  //     setStatus("Unpaid");
  //   }
  // }, [type]);

  const defaultProps = {
    options: currencies,
    getOptionLabel: (option) => option.label,
  };

  const clientsProps = {
    options: clients,
    getOptionLabel: (option) => option.name,
  };
  const suppliersProps = {
    options: suppliers,
    getOptionLabel: (option) => option.name || "",
  };
  const itemsProps = {
    options: items,
    getOptionLabel: (option) => option.itemName || "",
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleRates = (e) => {
    setRates(e.target.value);
    setPurchaseData((prevState) => ({ ...prevState, tax: e.target.value }));
  };
  const getAvailableStock = async (itemId) => {
    const data = await getCurrentStockQty(itemId);
    console.log(data);
    const currentStock = data.currentStock?.$numberDecimal || data.currentStock;
    return currentStock;
  };
  // console.log(purchaseData)
  // Change handler for dynamically added input field
  const handleChange = (index, e) => {
    const values = [...purchaseData.items];
    values[index][e.target.name] = e.target.value;
    setPurchaseData({ ...purchaseData, items: values });
  };
  //   const handleCostChange = (index, e) => {
  //     const { name, value } = e.target;

  //     // Create a deep copy of the items array
  //     const updatedItems = [...purchaseData.items];

  //     // Update the specific nested value
  //     if (updatedItems[index]?.item?.units?.purchase) {
  //         updatedItems[index].item.units.purchase[name] = value;
  //     }

  //     // Update the state with the modified items array
  //     setPurchaseData({ ...purchaseData, items: updatedItems });
  // };

  // useEffect(() => {
  //   const transformedItems = purchaseData.items.map((cartItem) => ({
  //     item: cartItem.id, // Extract id
  //     quantity: cartItem.quantity, // Extract quantity
  //   }));
  //   setPurchaseData({ ...purchaseData, items: transformedItems });
  // }, [purchaseData]);
  const handleNameChange = async (index, value) => {
    const updatedItems = [...purchaseData.items];

    try {
      const stock = await getAvailableStock(value.id); // Wait for the stock data

      updatedItems[index] = {
        ...updatedItems[index],
        item: value,
        currentStock: stock, // Use the resolved stock value
      };

      setPurchaseData({ ...purchaseData, items: updatedItems }); // Update state
      console.log("Items", updatedItems); // Use updatedItems to log correctly
      setEditQty(true);
    } catch (error) {
      console.error("Error fetching stock:", error);
    }
  };

  const displayItems = () => {
    console.log("Updated Item ", purchaseData.items);
    // dispatch(updateItems(updatedCartItems,openSnackbar))
  };
  let barcodeScan = "";
  useEffect(() => {
    function handleKeyDown(e) {
      // console.log("handle")
      if (e.keyCode === 13 && barcodeScan.length > 3) {
        console.log("Barcode Scan: " + barcodeScan);
        handleBarcodeScan(barcodeScan);
        return;
      }
      if (e.keyCode === 16) {
        return;
      }
      barcodeScan += e.key;
      setTimeout(() => {
        barcodeScan = "";
        console.log("Barcode Scan: " + barcodeScan);
      }, 100);
    }
    document.addEventListener("keydown", handleKeyDown);
    return function cleanup() {
      document.removeEventListener("keydown", handleKeyDown);
    };
  });
  const handleBarcodeScan = async (scannedValue) => {
    console.log("handleBarcodeScan Called");
    const scannedItem = scannedValue;
    // Find the item with a matching barcode
    const matchingItem = items.find(
      (item) => item.barcode === scannedItem || item.id === scannedItem
    );
    console.log("Matching", matchingItem);

    if (matchingItem) {
      try {
        // Get the current stock for this item
        const currentStock = await getAvailableStock(matchingItem.id);

        // Check if the item already exists in the purchaseData
        const existingItemIndex = purchaseData.items.findIndex(
          (item) => item.item?.id === matchingItem.id
        );

        if (existingItemIndex !== -1) {
          // If the item already exists, just increment the quantity
          const updatedItems = [...purchaseData.items];
          updatedItems[existingItemIndex].quantity =
            parseInt(updatedItems[existingItemIndex].quantity || 0, 10) + 1;

          setPurchaseData({ ...purchaseData, items: updatedItems });
        } else {
          // If it's a new item, add it with full details and quantity of 1
          const newItem = {
            item: matchingItem, // Store the full item object
            quantity: 1,
            cost: matchingItem.units?.purchase?.cost || 0, // Use purchase cost if available
            currentStock: currentStock, // Add current stock info
          };

          const updatedItems = [...purchaseData.items, newItem];
          setPurchaseData({ ...purchaseData, items: updatedItems });
        }
      } catch (error) {
        console.error("Error fetching stock:", error);
        openSnackbar("Error fetching stock information");
      }
    } else {
      openSnackbar(
        searchQuery
          ? "Item not found for the entered barcode. Please check."
          : "Item not found for the scanned barcode. Please check."
      );
    }
  };

  // const handleBarcodeScan = (scannedValue) => {
  //   console.log("handleBarcodeScan Called");
  //   const scannedItem = scannedValue;
  //   // Find the item with a matching barcode
  //   const matchingItem = items.find(
  //     (item) => item.barcode === scannedItem || item.id === scannedItem
  //   );
  //   console.log("Matching", matchingItem);
  //   if (matchingItem) {
  //     // Check if the item already exists in the purchaseData
  //     const existingItemIndex = purchaseData.items.findIndex(
  //       (item) => item.itemName === matchingItem.itemName
  //     );

  //     if (existingItemIndex !== -1) {
  //       // If the item already exists, update the quantity by one
  //       const updatedItems = [...purchaseData.items];
  //       updatedItems[existingItemIndex].quantity =
  //         parseInt(updatedItems[existingItemIndex].quantity, 10) + 1;

  //       setPurchaseData({ ...purchaseData, items: updatedItems });
  //     } else {
  //       // If it's a new item, add it with a quantity of 1
  //       const updatedItems = [...purchaseData.items];
  //       updatedItems.push({
  //         itemName: matchingItem,
  //         quantity: 1,
  //       });

  //       setPurchaseData({ ...purchaseData, items: updatedItems });
  //     }
  //   } else {
  //     {
  //       searchQuery
  //         ? openSnackbar(
  //             "Item not found for the entered barcode. Please check."
  //           )
  //         : openSnackbar(
  //             "Item not found for the scanned barcode. Please check."
  //           );
  //     }
  //   }
  // };

  const handleBarcodeInputChange = (e) => {
    setSearchQuery(e.target.value);
  };
  const handleSearchSubmit = async (e) => {
    e.preventDefault();
    handleBarcodeScan(searchQuery);
    // setSearchQuery("");
  };

  useEffect(() => {
    //Get the subtotal
    const subTotal = () => {
      var arr = document.getElementsByName("amount");
      var subtotal = 0;
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].value) {
          subtotal += +arr[i].value;
        }
        // document.getElementById("subtotal").value = subtotal;
        setSubTotal(subtotal);
      }
    };

    subTotal();
  }, [purchaseData]);

  // Update status based on payment mode
  useEffect(() => {
    if (purchaseData.paymentMode === "Credit") {
      setStatus("Unpaid");
      setPurchaseData((prevState) => ({
        ...prevState,
        supplierDue: total, // Set supplier due to total amount for Credit
      }));
    } else if (
      purchaseData.paymentMode === "Cash" ||
      purchaseData.paymentMode === "Online"
    ) {
      setStatus("Paid");
      setPurchaseData((prevState) => ({
        ...prevState,
        supplierDue: 0, // No due for Cash or Online
      }));
    }
  }, [purchaseData.paymentMode, total]);

  useEffect(() => {
    const total = () => {
      //Tax rate is calculated as (input / 100 ) * subtotal + subtotal
      const overallSum = subTotal;
      //VAT is calculated as tax rates /100 * subtotal
      setVat((rates / 100) * subTotal);
      setTotal(overallSum);
      if (purchaseData.items.length === 0) {
        setTotal(0);
      }
    };
    total();
  }, [purchaseData, rates, subTotal]);

  const handleAddField = (e) => {
    e.preventDefault();
    setPurchaseData((prevState) => ({
      ...prevState,
      items: [
        ...prevState.items,
        { item: {}, quantity: 0, cost: 0, currentStock: "" },
      ],
    }));
  };

  const handleRemoveField = (index) => {
    const values = purchaseData.items;
    values.splice(index, 1);
    setPurchaseData((prevState) => ({ ...prevState, values }));
    // console.log(values)
  };
  const handleClient = (value) => {
    setSelectedDate(today.getTime() + value?.dueDate * 24 * 60 * 60 * 1000);
  };
  // console.log(purchaseData);
  const findCategoryId = (id) => {
    const filteredItem = items.find((c) => c.id === id);

    return filteredItem.category.categoryId;
  };
  const createItemData = (item, quantity) => ({
    ...item, // Spread all properties from item
    quantity: parseFloat(quantity).toFixed(2), // Format quantity to 2 decimal places
  });

  const stockDetailsItems = async (cartItems, purchaseNumber) => {
    const stockItems = await Promise.all(
      cartItems.map(async (item) => ({
        item: item.item.id,
        transactionType: "PURCHASE",
        qty: await getConvertedQuantity(
          createItemData(item.item, item.quantity),
          "purchase"
        ),
        categoryId: item.item?.category?.categoryId,
        purchaseId: purchaseNumber,
        createdAt: new Date(),
        unit: item.item?.units?.purchase?.unit?.id,
        references: {
          purchaseId: purchaseNumber,
          transactionRef: "Purchase",
        },
        creator: toCreatorRef(user?.result?.id) ?? getAuthUserId(),
      }))
    );

    return stockItems;
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   const hasEmptyItems = purchaseData.items.some(
  //     (item) => !item.quantity && !item.paymentMode
  //   );
  //   if (
  //     hasEmptyItems ||
  //     // !subTotal ||
  //     !total
  //     // !vat ||
  //     // !rates ||
  //     //  !currency ||
  //     // !selectedDate ||
  //     // !client
  //     // !signatureDataUrl||
  //     // !supplier
  //     // !type ||
  //     // !status
  //   ) {
  //     // console.log("client", client);
  //     // Update the error state with an appropriate error message
  //     openSnackbar("Please fill the details");
  //     return;
  //   }
  //   // const currentDate = new Date();
  //   // const year = currentDate.getFullYear();
  //   // const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  //   // const day = String(currentDate.getDate()).padStart(2, "0");
  //   // const hours = String(currentDate.getHours()).padStart(2, "0");
  //   // const minutes = String(currentDate.getMinutes()).padStart(2, "0");
  //   // const seconds = String(currentDate.getSeconds()).padStart(2, "0");
  //   // const randomID = Math.floor(100 + Math.random() * 900);
  //   //    const purchaseNumber = `${randomID}${seconds}`;

  //   // const purchaseNumber = `${year}${month}${day}${hours}${minutes}${seconds}`;

  //   setError("");
  //   if (purchase) {

  //     dispatch(
  //       updatePurchase(purchase.id, {
  //         ...purchaseData,
  //         items: purchaseData.items.map((cartItem) => ({
  //           item: cartItem.item.id, // Extract id
  //           quantity: cartItem.quantity,
  //           cost:cartItem.cost// Extract quantity
  //         })),
  //         subTotal: subTotal,
  //         total: total,
  //         vat: vat,
  //         rates: rates,
  //         currency: currency,
  //         dueDate: selectedDate,
  //         client,
  //         supplier,
  //         type: type,
  //         status: status,
  //         isPrintBill: true,
  //       })
  //     );
  //     dispatch(deleteStockById(purchaseData.purchaseNumber, "PURCHASE"));
  //     dispatch(
  //       createPurchase(
  //         {
  //           ...purchaseData,
  //           items: purchaseData.items.map((cartItem) => ({
  //             item: cartItem.item.id, // Extract id
  //             quantity: cartItem.quantity,
  //             cost:cartItem.cost// Extract quantity
  //           })),
  //           subTotal: subTotal,
  //           total: total,
  //           vat: vat,
  //           rates: rates,
  //           currency: currency,
  //           dueDate: selectedDate,
  //           purchaseNumber: purchaseData.purchaseNumber,
  //           client: client ? client : defaultClient,
  //           supplier,
  //           type: type,
  //           status: status,
  //           paymentRecords: [],
  //           creator: [user?.result?.id || user?.result?.googleId],
  //           createdAt: new Date(),
  //           isPrintBill: true,
  //         },
  //         history
  //       )
  //     );
  //     console.log("purchaseData items", purchaseData.items);
  //     console.log(
  //       "stockDetailsItems",
  //       stockDetailsItems(purchaseData.items, purchaseData.purchaseNumber)
  //     );
  //     const stockTransactions = await stockDetailsItems(
  //       purchaseData.items,
  //       purchaseData.purchaseNumber
  //     );

  //     dispatch(createStock(stockTransactions));
  //     history.push(`/purchase/${purchase.id}`);
  //   } else {
  //     // const updatedCartItems = purchaseData.items.map((item) => {
  //     //   ;
  //     //   const filteredItem = items.find((i) => i.id === item.id); // Use `find` instead of `filter` to get a single item

  //     //   if (filteredItem) {
  //     //     // Check if the filtered item exists
  //     //     const quantity = parseFloat(item.quantity);
  //     //     const currentQty = parseFloat(item.currentQty);

  //     //     if (!isNaN(quantity) && !isNaN(currentQty)) {
  //     //       // Create a copy of the filtered item and update its fields
  //     //       const updatedItem = {
  //     //         ...filteredItem,
  //     //         stockQty: {
  //     //           ...filteredItem.stockQty,
  //     //           currentQty: currentQty + quantity,
  //     //         },
  //     //       };
  //     //       return updatedItem;
  //     //     } else {
  //     //       // Handle the case where the values are not valid numbers
  //     //       console.error("Invalid quantity or initialQty:", item);
  //     //       // You can choose to set a default value or skip updating the item
  //     //       return item; // or return a default value
  //     //     }
  //     //   } else {
  //     //     // Handle the case where the filtered item is not found
  //     //     console.error("Item not found for ID:", item.itemId);
  //     //     // You can choose to set a default value or skip updating the item
  //     //     return item; // or return a default value
  //     //   }
  //     // });
  //     // console.log("Updated Item ", updatedCartItems);
  //     // dispatch(updateItems(updatedCartItems, openSnackbar));

  //     dispatch(
  //       createPurchase(
  //         {
  //           ...purchaseData,
  //           items: purchaseData.items.map((cartItem) => ({
  //             item: cartItem.item.id, // Extract id
  //             quantity: cartItem.quantity,
  //             cost:cartItem.cost// Extract quantity
  //           })),
  //           subTotal: subTotal,
  //           total: total,
  //           vat: vat,
  //           rates: rates,
  //           currency: currency,
  //           dueDate: selectedDate,
  //           purchaseNumber: purchaseData.purchaseNumber,
  //           client: client ? client : defaultClient,
  //           supplier,
  //           type: type,
  //           status: status,
  //           paymentRecords: [],
  //           creator: [user?.result?.id || user?.result?.googleId],
  //           createdAt: new Date(),
  //           isPrintBill: true,
  //         },
  //         history
  //       )
  //     );
  //     console.log("purchaseData items", purchaseData.items);
  //     console.log(
  //       "stockDetailsItems",
  //       stockDetailsItems(purchaseData.items, purchaseData.purchaseNumber)
  //     );
  //     const stockTransactions = await stockDetailsItems(
  //       purchaseData.items,
  //       purchaseData.purchaseNumber
  //     );

  //     dispatch(createStock(stockTransactions));
  //   }

  //   setPurchaseData(initialStatePurchase);
  // };


  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const hasEmptyItems = purchaseData.items.some(
      (item) => !item.quantity || !item.cost
    );
    if (hasEmptyItems || !total || !purchaseData.paymentMode) {
      openSnackbar("Please fill all required details");
      return;
    }
  
    setError("");
  
    // Calculate total amount received from existing payment records
    const existingPaymentRecords = purchase?.paymentRecords || [];
    const totalAmountReceived = existingPaymentRecords.reduce(
      (sum, record) => sum + (record.amountPaid || 0),
      0
    );
  
    // Recalculate supplierDue and status
    // const newSupplierDue = total - totalAmountReceived;
    // const newStatus =
    //   newSupplierDue === 0
    //     ? "Paid"
    //     : newSupplierDue < total
    //     ? "Partially Paid"
    //     : "Unpaid";
  
// Determine status and supplierDue based on paymentMode
let newStatus = purchaseData.status;
let newSupplierDue = purchaseData.supplierDue || total;

if (
  purchaseData.paymentMode === "Cash" ||
  purchaseData.paymentMode === "Online"
) {
  newStatus = "Paid";
  newSupplierDue = 0;
} else if (purchaseData.paymentMode === "Credit") {
  newStatus = totalAmountReceived >= total ? "Paid" : totalAmountReceived > 0 ? "Partially Paid" : "Unpaid";
  newSupplierDue = total - totalAmountReceived;
}

    const purchasePayload = {
      ...purchaseData,
      items: purchaseData.items.map((cartItem) => ({
        item: cartItem.item.id,
        quantity: cartItem.quantity,
        cost: cartItem.cost,
      })),
      subTotal: subTotal,
      total: total,
      vat: vat,
      rates: rates,
      currency: currency,
      dueDate: selectedDate,
      client: client ? client : defaultClient,
      supplier: supplier
        ? {
            id: supplier.id,
            name: supplier.name,
            email: supplier.email || "",
            phone: supplier.phone || "",
            address: supplier.address || "",
          }
        : null,
      type: type,
      status: newStatus, // Updated status
      paymentRecords: existingPaymentRecords, // Preserve existing payment records
      creator: [toCreatorRef(user?.result?.id)].filter((x) => x != null),
      createdAt: purchase ? purchase.createdAt : new Date(), // Preserve original createdAt for updates
      isPrintBill: true,
      supplierDue: newSupplierDue, // Updated supplierDue
      totalAmountReceived: totalAmountReceived, // Preserve total amount received
    };
  
    if (purchase) {
      // Update existing purchase
      await dispatch(updatePurchase(purchase.id, purchasePayload));
      // Update stock transactions
      await dispatch(deleteStockById(purchaseData.purchaseNumber, "PURCHASE"));
      const stockTransactions = await stockDetailsItems(
        purchaseData.items,
        purchaseData.purchaseNumber
      );
      await dispatch(createStock(stockTransactions));
      history.push(`/purchase/${purchase.id}`);
    } else {
      // Create new purchase
      await dispatch(createPurchase(purchasePayload, history));
      const stockTransactions = await stockDetailsItems(
        purchaseData.items,
        purchaseData.purchaseNumber
      );
      await dispatch(createStock(stockTransactions));
    }
  
    setPurchaseData(initialStatePurchase);
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   const hasEmptyItems = purchaseData.items.some(
  //     (item) => !item.quantity || !item.cost
  //   );
  //   if (hasEmptyItems || !total || !purchaseData.paymentMode) {
  //     openSnackbar("Please fill all required details");
  //     return;
  //   }

  //   setError("");
  //   const purchasePayload = {
  //     ...purchaseData,
  //     items: purchaseData.items.map((cartItem) => ({
  //       item: cartItem.item.id,
  //       quantity: cartItem.quantity,
  //       cost: cartItem.cost,
  //     })),
  //     subTotal: subTotal,
  //     total: total,
  //     vat: vat,
  //     rates: rates,
  //     currency: currency,
  //     dueDate: selectedDate,
  //     client: client ? client : defaultClient,
  //     supplier: supplier
  //       ? {
  //           id: supplier.id, // Ensure the supplier ID is included
  //           name: supplier.name,
  //           email: supplier.email || "",
  //           phone: supplier.phone || "",
  //           address: supplier.address || "",
  //         }
  //       : null, // Handle case where supplier is not selected
  //     type: type,
  //     status: status,
  //     paymentRecords: [],
  //     creator: [user?.result?.id || user?.result?.googleId],
  //     createdAt: new Date(),
  //     isPrintBill: true,
  //     supplierDue: purchaseData.supplierDue || 0,
  //   };

  //   if (purchase) {
  //     dispatch(updatePurchase(purchase.id, purchasePayload));
  //     dispatch(deleteStockById(purchaseData.purchaseNumber, "PURCHASE"));
  //     dispatch(createPurchase(purchasePayload, history));
  //     const stockTransactions = await stockDetailsItems(
  //       purchaseData.items,
  //       purchaseData.purchaseNumber
  //     );
  //     dispatch(createStock(stockTransactions));
  //     history.push(`/purchase/${purchase.id}`);
  //   } else {
  //     dispatch(createPurchase(purchasePayload, history));
  //     const stockTransactions = await stockDetailsItems(
  //       purchaseData.items,
  //       purchaseData.purchaseNumber
  //     );
  //     dispatch(createStock(stockTransactions));
  //   }

  //   setPurchaseData(initialStatePurchase);
  // };
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  // const [openSupplier, setOpenSupplier] = useState(false);
  const CustomPaper = (props) => {
    return <Paper elevation={3} {...props} />;
  };

  if (!user) {
    history.push("/login");
  }
  // const filteredItems = useMemo(() => {
  //   return items.filter((item) => item.toggleStock === true);
  // }, [items]);
  const filteredItems = useMemo(() => {
    return items.filter((item) => item.toggleStock === true && item.isActive);
  }, [items]);

  return (
    <div className={styles.purchaseLayout}>
      <form onSubmit={handleSubmit} className="mu-form">
        {/* <AddClient setOpen={setOpen} open={open} /> */}
        <AddSupplier setOpen={setOpen} open={open} />
        <Container className={classes.headerContainer}>
          <Grid container justifyContent="center">
            <Grid item>
              <PurchaseType type={type} setType={setType} />
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {/* <span style={{ marginRight: "10px", fontWeight: "bold" }}>
                  ID:
                </span> */}
                <div
                  style={{
                    padding: "8px",
                    borderRadius: "4px",
                  }}
                >
                  {/* <Typography variant="body2" color="initial">
                      {purchaseData.purchaseNumber}
                    </Typography> */}
                  <p>
                    {purchase
                      ? moment(purchase.createdAt).format(" Do MMM YYYY")
                      : moment().format("Do MMM YYYY")}
                  </p>
                </div>
              </div>
            </Grid>
          </Grid>
        </Container>
        <Divider />
        <Grid
          container
          justifyContent="space-between"
          style={{ marginTop: "4px" }}
        >
          <Grid item xs={12} md={6} style={{ paddingRight: "10px" }}>
            <Container>
              {supplier && (
                <>
                  <Typography variant="subtitle1" gutterBottom>
                    {supplier.name}
                  </Typography>

                  {/* <Typography variant="body2">{client.email}</Typography> */}
                  <Typography variant="body1">{supplier.phone}</Typography>
                  {/* <Typography variant="body2">{client.address}</Typography>
                  <Typography variant="body2">{client.dueDate}</Typography> */}
                  {/* <Typography variant="body2">
                      {client.dueDate} Credit Days
                    </Typography> */}
                  <Button
                    color="primary"
                    size="small"
                    style={{
                      textTransform: "none",
                      backgroundColor: "#ef7f1a",
                      color: "white",
                    }}
                    onClick={() => setSupplier(null)}
                  >
                    Change
                  </Button>
                </>
              )}
              <div
                style={supplier ? { display: "none" } : { display: "block" }}
              >
                <Autocomplete
                  {...suppliersProps}
                  PaperComponent={CustomPaper}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      required={!purchase && true}
                      label="Select Supplier"
                      margin="normal"
                      variant="outlined"
                    />
                  )}
                  value={suppliers?.name}
                  onChange={(event, value) => {
                    setSupplier(value);
                    handleClient(value);
                  }}
                  // onChange={(event, value) => setClient(value) }
                />
              </div>
              {!supplier && (
                <>
                  <Grid item style={{ paddingBottom: "10px" }}>
                    <Chip
                      avatar={
                        <Avatar
                          style={{ backgroundColor: "#ef7f1a", color: "white" }}
                        >
                          +
                        </Avatar>
                      }
                      label="New Supplier"
                      onClick={() => setOpen(true)}
                      variant="outlined"
                    />
                  </Grid>
                </>
              )}
            </Container>
          </Grid>
          <Grid item xs={12} md={6} style={{ paddingRight: "10px" }}>
            <Container>
              <div style={{ marginTop: "6.5px" }}>
                <FormControl variant="outlined" className={classes.formControl}>
                  <InputLabel id="demo-simple-select-outlined-label">
                    Payment Mode
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    value={purchaseData.paymentMode}
                    required={true}
                    onChange={(e) => {
                      // console.log("Purchase.js me  signature console.log",signatureDataUrl)
                      setPurchaseData({
                        ...purchaseData,
                        paymentMode: e.target.value,
                      });
                    }}
                    label="Payment Method"
                  >
                    <MenuItem value="Select">
                      <em>None</em>
                    </MenuItem>
                    <MenuItem value="Cash">Cash</MenuItem>
                    <MenuItem value="Online">Online</MenuItem>
                    <MenuItem value="Credit">Credit</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </Container>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            style={{ textAlign: "right", marginBottom: "10px" }}
          >
            <Container
              style={{
                display: "flex",
                alignItems: "end",
                justifyContent: "start",
                textAlign: "center",
              }}
            >
              <TextField
                id="search-bar"
                label="Enter Barcode"
                variant="outlined"
                margin="normal"
                value={searchQuery}
                onChange={handleBarcodeInputChange}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    // Execute your function here with e.target.value
                    e.preventDefault();
                  }
                }}
              />
              {searchQuery && (
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={handleSearchSubmit}
                  style={{ margin: "0 0 20px 20px" }}
                >
                  Add Item
                </Button>
              )}
            </Container>
          </Grid>
        </Grid>

        <div>
          <TableContainer component={Paper} className="tb-container">
            <Table className={classes.table} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell style={{ fontSize: "20px" }}>Delete</TableCell>
                  <TableCell style={{ fontSize: "20px" }}>Item</TableCell>
                  <TableCell style={{ fontSize: "20px" }}>Unit</TableCell>
                  {!purchase && (
                    <TableCell style={{ fontSize: "20px" }}>
                      Available Stock
                    </TableCell>
                  )}
                  <TableCell style={{ fontSize: "20px" }}>Qty</TableCell>
                  <TableCell style={{ fontSize: "20px" }}>MRP</TableCell>
                  <TableCell align="center" style={{ fontSize: "20px" }}>
                    Amount
                  </TableCell>
                </TableRow>
              </TableHead>
        
              <TableBody>
                {purchaseData.items.map((itemField, index) => {
                  console.log("itemField:", itemField); // Log the itemField object
                  console.log("itemName:", itemField?.item?.itemName); // Safely log itemName

                  return (
                    <TableRow key={index}>
                      <TableCell align="left">
                        <IconButton
                          style={{ border: "1px solid red" }}
                          onClick={() => handleRemoveField(index)}
                        >
                          <DeleteOutlineRoundedIcon
                            style={{
                              width: "20px",
                              height: "20px",
                              color: "red",
                            }}
                          />
                        </IconButton>
                      </TableCell>
                      <TableCell
                        align="left"
                        style={{ cursor: "context-menu", fontSize: "18px" }}
                      >
                        {itemField?.item?.itemName || ""}
                        <div
                          style={
                            itemField?.item?.itemName
                              ? { display: "none" }
                              : { display: "block" }
                          }
                        >
                          <FormControl variant="outlined" fullWidth>
                            <Autocomplete
                              options={filteredItems}
                              getOptionLabel={(item) => item.itemName || ""}
                              value={itemField?.item || null}
                              onChange={(e, value) => {
                                handleNameChange(index, value || "");
                                inputRef.current.focus();
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  variant="outlined"
                                  placeholder="Search Item"
                                  fullWidth
                                />
                              )}
                            />
                          </FormControl>
                        </div>
                      </TableCell>
                      <TableCell
                        align="left"
                        style={{ cursor: "context-menu", fontSize: "18px" }}
                      >
                        {itemField?.item?.units?.purchase?.unit?.name || ""}
                      </TableCell>
                      {!purchase && (
                        <TableCell
                          align="left"
                          style={{ cursor: "context-menu", fontSize: "18px" }}
                        >
                          {itemField?.item?.itemName
                            ? `${itemField.currentStock.toFixed(2)} ${
                                itemField?.item?.units?.stock?.unit
                                  ?.abbreviation || ""
                              }`
                            : 0}
                        </TableCell>
                      )}
                      <TableCell align="left" style={{ fontSize: "18px" }}>
                        <InputBase
                          inputRef={inputRef}
                          sx={{ ml: 1, flex: 1, width: "10px" }}
                          type="number"
                          name="quantity"
                          onChange={(e) => handleChange(index, e)}
                          value={itemField?.quantity || "0"}
                          placeholder="0"
                          style={{ fontSize: "18px", width: "60px" }}
                        />
                      </TableCell>
                      <TableCell
                        align="left"
                        style={{ cursor: "context-menu", fontSize: "18px" }}
                      >
                        <InputBase
                          sx={{ ml: 1, flex: 1, width: "10px" }}
                          type="number"
                          name="cost"
                          onChange={(e) => handleChange(index, e)}
                          value={itemField?.cost || "0"}
                          placeholder="0"
                          style={{ fontSize: "18px", width: "60px" }}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <InputBase
                          sx={{ ml: 1, flex: 1 }}
                          type="number"
                          name="amount"
                          onChange={(e) => handleChange(index, e)}
                          value={itemField?.quantity * itemField?.cost || 0}
                          disabled
                          style={{ fontSize: "18px", display: "none" }}
                        />
                        <Typography variant="h5" color="initial">
                          {itemField?.quantity * itemField?.cost || 0}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <div className={styles.addButton}>
            <button
              onClick={handleAddField}
              style={{ backgroundColor: "#ef7f1a", color: "white" }}
              // disabled={scanning}
            >
              +
            </button>
          </div>
        </div>
        {/* <div>
          <Grid
            item
            xs={12}
            md={6}
            style={{ paddingRight: "10px", marginTop: "10px" }}
          >
            <Container></Container>
          </Grid> */}
        <div className={styles.purchaseSummary}>
          <div className={styles.summary}>Order Summary</div>
          <div className={styles.summaryItem}>
            <p>Total Items:</p>
            <h4>
              {purchaseData.items.reduce((accumulator, item) => {
                const quantity = parseInt(item.quantity, 10) || 0; // Use 0 if item.quantity is empty or not a number
                return accumulator + quantity;
              }, 0)}
            </h4>
          </div>
          {purchaseData.paymentMode && (
            <div className={styles.summaryItem}>
              <p>Payment Mode:</p>
              <h4>{purchaseData.paymentMode}</h4>
            </div>
          )}

          <div className={styles.summaryItem}>
            <h2 style={{ marginLeft: "14px" }}>Total</h2>
            <h2 style={{ padding: "12px" }}>
              {currency} {toCommas(total)}
            </h2>
          </div>
        </div>
        {/* </div> */}
        {/* <div className={styles.toolBar}>
          <Container>
            <Grid container>
              <Grid item style={{ marginTop: "16px", marginRight: 40 }}>
                <TextField
                  type="text"
                  step="any"
                  name="rates"
                  id="rates"
                  value={rates}
                  onChange={handleRates}
                  placeholder="e.g 10"
                  label="Discount(%)"
                />
              </Grid> */}
        {/* <Grid item style={{ marginRight: 10, marginLeft: 80 }}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    margin="normal"
                    id="date-picker-dialog"
                    label="Due date"
                    format="MM/dd/yyyy"
                    value={selectedDate}
                    onChange={handleDateChange}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                </MuiPickersUtilsProvider>
              </Grid> */}
        {/* <Grid item style={{ width: 270, marginRight: 10 }}>
                <Autocomplete
                  {...defaultProps}
                  id="debug"
                  debug
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select currency"
                      margin="normal"
                    />
                  )}
                  value={currency.value}
                  onChange={(event, value) => setCurrency(value.value)}
                />
              </Grid> */}
        {/* </Grid>
          </Container>
        </div> */}
        <br />
        {/* {signatureDataUrl ? (
               <div>
            
              <img src={signatureDataUrl} alt="signature" className="signature" width={150} height={150}/>
             
              
              <Button
                    color="primary"
                    size="small"
                    style={{
                      textTransform: "none",
                      backgroundColor: "#ef7f1a",
                      color: "white",
                      margin:5
                    }}
                    onClick={() => setSignatureDataUrl(null)}
                  >
                    Change
                  </Button>
                  </div>
            ):<div>
           
            <SignaturePad setSignatureDataUrl={setSignatureDataUrl}/>{
             
            }
          </div>} */}

        <div className={styles.note}>
          <h4>Notes/Payment Info</h4>
          <textarea
            style={{ border: "solid 1px #d6d6d6", padding: "10px" }}
            placeholder="Provide additional details or terms of service"
            onChange={(e) => {
              // console.log("Purchase.js me  signature console.log",signatureDataUrl)
              setPurchaseData({ ...purchaseData, notes: e.target.value });
            }}
            value={purchaseData.notes}
          />
        </div>

        {/* <button className={styles.submitButton} type="submit">Save and continue</button> */}
        <Grid container justifyContent="center">
          <Button
            variant="contained"
            style={{
              justifyContentContent: "center",
              backgroundColor: "#ef7f1a",
              color: "white",
            }}
            type="submit"
            color="primary"
            size="large"
            className={classes.button}
            startIcon={<SaveIcon />}
          >
            Save and Continue
          </Button>
          {error && (
            <Grid
              container
              justifyContent="center"
              style={{ marginTop: "10px" }}
            >
              <Typography variant="body2" color="error">
                {error}
              </Typography>
            </Grid>
          )}
        </Grid>
      </form>
    </div>
  );
};

export default Purchase;
